<script>
export default {
  functional: true,

  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },

  render(h, { data, props, slots, $style, elementUiStyles }) {
    return (
      <div
        {...data}
        {...{ directives: [{ name: 'loading', value: props.loading }] }}
        element-loading-background="rgba(0, 0, 0, 0.75)"
        element-loading-custom-class={elementUiStyles.loadingMask}
      >
        <mq-layout mq="sm" style={{ marginBottom: '-0.5rem' }}>
          {slots().default &&
            slots().default.map(vnode => (
              <div style={{ paddingBottom: '0.5rem' }}>{vnode}</div>
            ))}
        </mq-layout>
        <mq-layout mq="md+">
          {slots().default && (
            <el-row type="flex" gutter={16}>
              {slots().default.map(vnode => (
                <el-col
                  span={null}
                  style={{ width: '100%' }}
                  class={$style.caseTrackersCol}
                >
                  {vnode}
                </el-col>
              ))}
            </el-row>
          )}
        </mq-layout>
      </div>
    )
  }
}
</script>

<style lang="scss" module>
.caseTrackersCol {
  border-left: 1px solid #979797;
  border-right: 1px solid #979797;

  &:first-child {
    border-left-color: transparent;
  }

  &:last-child {
    border-right-color: transparent;
  }
}
</style>

<style
  src="@/assets/scss/modules/element-ui.module.scss"
  lang="scss"
  module="elementUiStyles"
></style>
